var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trustable"},[_c('TrustableHero'),_c('HomeNews'),_c('TrustableContent'),_c('Reports'),_c('Footer',{attrs:{"hasCall":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }